export default __webpack_public_path__ + "static/media/banner.b797e19c.png";